import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase';

function SubeSecimi() {
  const navigate = useNavigate();
  const [loadingSube, setLoadingSube] = useState('');
  const [error, setError] = useState('');

  const storePassword = useMemo(() => {
    return String(sessionStorage.getItem('UKBA_STORE_PASSWORD') || '').trim();
  }, []);

  const subeAccounts = useMemo(() => ({
    sefakoy_merkez: 'sefakoy_merkez@ukba-kasa.online',
    sefakoy_sube: 'sefakoy_sube@ukba-kasa.online',
    kavakli_sube: 'kavakli_sube@ukba-kasa.online'
  }), []);

  const handleSelectSube = async (subeKey) => {
    setError('');
    if (!storePassword) {
      navigate('/giris', { replace: true });
      return;
    }
    const email = subeAccounts[subeKey];
    if (!email) {
      setError('Şube hesabı bulunamadı.');
      return;
    }
    setLoadingSube(subeKey);
    try {
      await signInWithEmailAndPassword(auth, email, storePassword);
      sessionStorage.removeItem('UKBA_STORE_PASSWORD');
      navigate(`/subegirisi?sube=${subeKey}`);
    } catch (err) {
      console.error(err);
      setError('Şube oturumu açılamadı. Mağaza şifresi veya şube hesabı kontrol ediniz.');
    } finally {
      setLoadingSube('');
    }
  };

  return (
    <div
      className="ukba-branch-page"
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f5f5f5',
        fontFamily: "'Helvetica Neue', sans-serif"
      }}
    >
      <div className="ukba-branch-wrap" style={{ textAlign: 'center' }}>
        <h2 className="ukba-branch-title" style={{ fontSize: '33px', marginBottom: '30px', color: '#000' }}>
          Şube Seçimi
        </h2>

        {error && (
          <div style={{
            width: '300px',
            margin: '0 auto 14px auto',
            padding: '10px 12px',
            backgroundColor: '#fee2e2',
            color: '#b91c1c',
            borderRadius: '8px',
            fontSize: '14px',
            fontWeight: '700',
            boxSizing: 'border-box'
          }}>
            {error}
          </div>
        )}

        <button
          onClick={() => handleSelectSube('sefakoy_merkez')}
          disabled={!!loadingSube}
          className="ukba-branch-btn"
          style={{
            display: 'block', width: '300px', height: '60px', fontSize: '24px',
            cursor: 'pointer', borderRadius: '8px', border: 'none',
            backgroundColor: '#000', color: '#fff', margin: '10px auto',
            transition: 'background-color 0.3s'
          }}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#333'}
          onMouseLeave={(e) => e.target.style.backgroundColor = '#000'}
        >
          {loadingSube === 'sefakoy_merkez' ? 'Açılıyor...' : 'Sefaköy Merkez Mağaza'}
        </button>

        <button
          onClick={() => handleSelectSube('sefakoy_sube')}
          disabled={!!loadingSube}
          className="ukba-branch-btn"
          style={{
            display: 'block', width: '300px', height: '60px', fontSize: '24px',
            cursor: 'pointer', borderRadius: '8px', border: 'none',
            backgroundColor: '#000', color: '#fff', margin: '10px auto',
            transition: 'background-color 0.3s'
          }}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#333'}
          onMouseLeave={(e) => e.target.style.backgroundColor = '#000'}
        >
          {loadingSube === 'sefakoy_sube' ? 'Açılıyor...' : 'Sefaköy Şube Mağaza'}
        </button>

        <button
          onClick={() => handleSelectSube('kavakli_sube')}
          disabled={!!loadingSube}
          className="ukba-branch-btn"
          style={{
            display: 'block', width: '300px', height: '60px', fontSize: '24px',
            cursor: 'pointer', borderRadius: '8px', border: 'none',
            backgroundColor: '#000', color: '#fff', margin: '10px auto',
            transition: 'background-color 0.3s'
          }}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#333'}
          onMouseLeave={(e) => e.target.style.backgroundColor = '#000'}
        >
          {loadingSube === 'kavakli_sube' ? 'Açılıyor...' : 'Kavaklı Şube Mağaza'}
        </button>
      </div>
    </div>
  );
}

export default SubeSecimi;
